import { Box, Grid } from '@mui/material';
import classNames from 'classnames';
import CreateOrderFooter from '../CreateOrderFooter';
import OrderBookHeader from '../OrderBookHeader';
import { useOrderBookStyles } from '../styles/OrderBookStyles';

const CreateNewOrderOnBook = () => {
  const { classes } = useOrderBookStyles();

  return (
    <Grid container className={classes.orderBookContainer}>
      <Grid className={classes.item}>
        <Box className={classNames(classes.footerTitleContainer, classes.horizontalPadding)}>
          <OrderBookHeader />
        </Box>
      </Grid>
      <Grid className={classNames(classes.item, classes.marginBottom)}>
        <Box className={classes.horizontalPadding}>
          <CreateOrderFooter />
        </Box>
      </Grid>
    </Grid>
  );
};

export default CreateNewOrderOnBook;
